import React from "react";
import { Link } from "react-router-dom";
import { FaWhatsapp } from 'react-icons/fa';

const IntroductionAreaOne = () => {
  return (
    <section id="intro" className="introduction-area pb-130">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-6 col-md-9">
            <div className="introduction-img-wrap">
              <img src="/img/images/introduction_img01.png" alt="" />
              <img
                src="/img/images/introduction_img02.png"
                data-aos="fade-right"
                alt=""
              />

              {/* <Popup
                trigger={
                  <div className="play-btn">
                    <a
                      href="#intro"
                      className="popup-video"
                      onClick={(e) => e.preventDefault()}
                    >
                      <i className="fas fa-play"></i>
                    </a>
                  </div>
                }
                position=""
                modal={true}
              >
                <Iframe
                  url="https://www.youtube.com/embed/XMWYZ-uZjnQ"
                  width="100%"
                  height="350px"
                  id=""
                  className=""
                  display="block"
                  position="relative"
                />
              </Popup> */}
            </div>
          </div>

          <div className="col-lg-6">
            <div className="introduction-content">
              <div className="section-title-two mb-20 tg-heading-subheading animation-style2">
                <span className="sub-title">Local Handyman Services</span>
                <h2 className="title tg-element-title">
                  Professional Handyman Services<br />
                  in Kuala Lumpur & Malaysia
                </h2>
              </div>

              <p className="info-one">
                FRG Renovation Works offers complete handyman services and home renovation solutions across Kuala Lumpur, Selangor and every major city in Malaysia. Whether you need a quick home repair, a small home repair service, or a full-scale house renovation contractor near you, our licensed handymen bring the right skills to every job.
              </p>
              <p>
                From kitchen and bathroom renovation, plumbing and electrical repairs to painting, flooring and emergency handyman services, our home improvement experts deliver affordable, reliable, and long-lasting results for homeowners and businesses alike.
              </p>

              <div className="introduction-list">
                <ul className="list-wrap">
                  <li>
                    <i className="fas fa-check-circle"></i>Licensed & Insured Handymen
                  </li>
                  <li>
                    <i className="fas fa-check-circle"></i>Home Renovation Contractor
                  </li>
                  <li>
                    <i className="fas fa-check-circle"></i>Emergency Home Repair
                  </li>
                  <li>
                    <i className="fas fa-check-circle"></i>Trusted Local Experts
                  </li>
                  <li>
                    <i className="fas fa-check-circle"></i>Residential Renovation Services
                  </li>
                  <li>
                    <i className="fas fa-check-circle"></i>Commercial Remodeling
                  </li>
                </ul>
              </div>

              <div className="introduction-bottom">
              <Link to="https://wa.me/+601135160242" className="btn" 
              target="_blank" rel="noopener noreferrer">
                <FaWhatsapp style={{ marginRight: '8px', fontSize: '24px' }} />
                WhatsApp
              </Link>

                <span className="call-now">
                  <i className="fas fa-phone-alt"></i>
                  <a href="tel:+601135160242">+60 11-3516 0242</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroductionAreaOne;
